import { ChartCard } from '../ChartCard';

import { IChartCardProps } from 'models';

export function BarChartCard<T>({
	data,
	getData,
	isProfit,
	subtitle,
	title,
	bars,
	total,
	minPointSize
}: IChartCardProps<T>) {
	return (
		<ChartCard
			title={title}
			isProfit={isProfit}
			getData={getData}
			subtitle={subtitle}
			isBar
			data={data}
			total={total}
			bars={bars}
			minPointSize={minPointSize}
		/>
	);
}
